<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Pradiniai prašymai') }}</h1>
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Naujas prašymas"
      :loading="loading"
      @click.native.stop="newItem()"
    />
    <!-- search -->
    <prepared-sent-requests-search @downloadReport="downloadReport" :loading="loading" @search="searchObject" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @duplicateItem="duplicateItem(item)"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <!-- custom templates -->
      <template #[`item.in_journal_type`]="{ item }">
        <el-table-enum
          enumName="inJournalType"
          :item="item.in_journal_type.toString()"
        />
      </template>
      <template #[`item.status`]="{ item }">
        <el-table-enum
          enumName="journalType"
          :item="item.status.toString()"
        />
      </template>
      <template #[`item.active`]="{ item }">
        <span>{{ item.active ? $t('Taip') : $t('Ne') }}</span>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import PreparedSentRequestsSearch from './PreparedSentRequestsSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'

export default {
  name: 'PreparedSentRequests',
  components: {
    PreparedSentRequestsSearch,
    ModalDelete,
  },
  mixins: [userRole, tableParameters, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Prašymo tipas'),
          align: 'start',
          value: 'in_journal_type',
        },
        {
          text: this.$t('Prašymo numeris'),
          align: 'start',
          value: 'request_number',
        },
        {
          text: this.$t('Prašymo būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Prašymo būsenos data'),
          align: 'start',
          value: 'status_date',
        },
        {
          text: this.$t('Reg. Nr. gautų dokumentų žurnale'),
          align: 'start',
          value: 'journal_no',
        },
        {
          text: this.$t('Registro objekto ID'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Prokūrą išdavęs JA'),
          align: 'start',
          value: 'pro_principal_name',
        },
        {
          text: this.$t('Prokūrą išdavęs JA kodas'),
          align: 'start',
          value: 'pro_principal_code',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    newItem() {
      this.$router.push({
        name: 'adminRequestNew',
      })
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`in-journals/requests/list`, data)
        .then((res) => {
          this.listData = res.data.requests
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchObject(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },

    editItem(item) {
      this.$router.push({
        name: 'adminRequestListNew',
        params: {
          id: item.id,
        },
      })
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
     openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`in-journals/requests/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`sent-requests/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
